import { GetEntityConfigsFunction } from '../types';

import { ENTITIES_CONFIGS } from './entity-configs';

export const getEntityConfigs: GetEntityConfigsFunction = ({ entity }) => {
  const configs = ENTITIES_CONFIGS[entity] ?? {};

  return Object.keys(configs).length === 0 ? null : configs;
};
